import { useEffect, useState } from "react";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import Map from "./components/Map/Map";
import Menu from "./components/Menu/Menu";
import { PlacesAutocomplete } from "./components/searchBar/PlacesAutocomplete.js";
import "./index.css";

function App() {
  const [allDetails, setAllDetails] = useState([]);
  const [departure, setDeparture] = useState("");
  const [arrival, setArrival] = useState("");
  const [distances, setDistances] = useState({});
  const [durations, setDurations] = useState({});
  const [showOnMap, setShowOnMap] = useState(null);
  const [directions, setDirections] = useState({});
  const [travelMode, setTravelMode] = useState("DRIVING");
  const [activeMarker, setActiveMarker] = useState(null);

  //FIND GEOCODE OF ARRIVAL AND DEPARTURE

  const findGeocodeFromId = (id) => {
    const arrivalIndex = allDetails.findIndex((elt) => elt.id === id);
    return allDetails[arrivalIndex].geocode;
  };

  const departureGeo = departure && findGeocodeFromId(departure);

  const findDistanceAndDurationFromDeparture = async (id) => {
    const directionsService = new window.google.maps.DirectionsService();
    const results = await directionsService.route({
      origin: findGeocodeFromId(departure),
      destination: findGeocodeFromId(id),
      travelMode: travelMode,
    });

    setDistances((prev) => ({
      ...prev,
      [id]: results.routes[0].legs[0].distance.text,
    }));
    setDurations((prev) => ({
      ...prev,
      [id]: results.routes[0].legs[0].duration.text,
    }));
    setDirections((prev) => ({
      ...prev,
      [id]: results,
    }));
  };

  const handleDelete = (id) => {
    if (id === departure || id === arrival) {
      setArrival("");
      setDeparture("");
      if (id === arrival) setDirections((prev) => ({ ...prev, [id]: null }));
    }
    setAllDetails((prev) => {
      return prev.filter((elt) => elt.id !== id);
    });
  };

  useEffect(() => {
    if (allDetails.length > 1 && departure) {
      allDetails.forEach(function (elt) {
        if (elt.id !== departure) {
          findDistanceAndDurationFromDeparture(elt.id);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departure, allDetails, travelMode]);

  return (
    <div className="flex flex-col h-[100vh] relative">
      <ReactNotifications />
      <div className="flex justify-center  m-auto mt-5 absolute w-full z-10 mobile-search">
        <PlacesAutocomplete
          setAllDetails={setAllDetails}
          allDetails={allDetails}
          setActiveMarker={setActiveMarker}
        />
      </div>
      <div className="flex justify-around h-[80%] mt-24 mobile-block">
        <Menu
          allDetails={allDetails}
          setDeparture={setDeparture}
          setArrival={setArrival}
          departure={departure}
          arrival={arrival}
          distances={distances}
          durations={durations}
          setShowOnMap={setShowOnMap}
          handleDelete={handleDelete}
          travelMode={travelMode}
          setTravelMode={setTravelMode}
        />
        <Map
          allDetails={allDetails}
          departureGeo={departureGeo}
          showOnMap={showOnMap}
          directions={directions[arrival] || null}
          activeMarker={activeMarker}
          setActiveMarker={setActiveMarker}
        />
      </div>
    </div>
  );
}

export default App;
